import { USER_MANAGEMENT_API, USER_MANAGEMENT_CREATE_API } from "../../constants/constants"
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor"
import { setEditSuccessMessage, setEmailUpdateSuccessMessage } from "../../toastMessage/action"
import { toast } from "react-toastify"
import { fetchUpdateUserFailure, fetchUpdateUserSuccess } from "./reducer"
import { documentUpdateJson, uploadDocApiCall } from "../../../Components/UserManagement/Constant/JsonConstant"
import { documentUpdateFile } from "../../customer/documentupdatefile/thunk"

export const updateUser = (
    setLoading, 
    formattedValues, 
    navigate, 
    userId, 
    isProfile,
    isViewOperator, 
    profile, 
    update, 
    setUpdate, 
    fileSelected, 
    logoFile, 
    editData, 
    setFileSelected,
    onSuccessCallback // Add the callback parameter
) => (dispatch) => {
    const roleName = localStorage.getItem("roleName")
    setLoading(true)
    
    determineBaseUrlAndPerformApiCall(`${USER_MANAGEMENT_CREATE_API}/${userId}`, 'PATCH', formattedValues).then((response) => {
        if (!response.error) {
            setLoading(false)
            dispatch(fetchUpdateUserSuccess(response))
            
            // FIXED: Handle different scenarios with proper toast timing
            const handleSuccess = () => {
                if (isProfile) {
                    // Handle profile updates
                    if (roleName === 'telcoEditor') {
                        // Show toast first, then navigate after delay
                        if (response.message) {
                            dispatch(setEmailUpdateSuccessMessage(true))
                        } else {
                            dispatch(setEditSuccessMessage(true))
                        }
                        setTimeout(() => navigate("/dashboard"), 1500)
                    } else if (roleName === 'systemUser') {
                        if (response.message) {
                            dispatch(setEmailUpdateSuccessMessage(true))
                        } else {
                            dispatch(setEditSuccessMessage(true))
                        }
                        setTimeout(() => navigate("/operator-listing"), 1500)
                    } else {
                        if (response.message) {
                            dispatch(setEmailUpdateSuccessMessage(true))
                        } else {
                            dispatch(setEditSuccessMessage(true))
                        }
                        setTimeout(() => navigate("/user"), 1500)
                    }
                } else {
                    // Handle regular user management updates
                    if (response.message) {
                        dispatch(setEmailUpdateSuccessMessage(true))
                    } else {
                        dispatch(setEditSuccessMessage(true))
                    }
                    
                    // Check if this is a modal context (onSuccessCallback exists)
                    if (onSuccessCallback) {
                        // This is a modal context - call the callback instead of navigating
                        setTimeout(() => {
                            onSuccessCallback('update')
                        }, 1500)
                    } else if (isViewOperator){
                        dispatch(setEditSuccessMessage(true))
                    } else {
                        // Regular page context - navigate after showing toast
                        setTimeout(() => navigate("/user"), 1500)
                    }
                }
            };

            // Handle file upload scenarios
            if (logoFile) {
                if (profile && update) {
                    setUpdate(false)
                }
                if (fileSelected && logoFile !== null) {
                    if (profile && update) {
                        const jsonObj = documentUpdateJson(logoFile, userId, editData)
                        let partnerOrCustomer = "User";
                        dispatch(documentUpdateFile(
                            setLoading, 
                            jsonObj, 
                            userId,
                            "logo", 
                            partnerOrCustomer, 
                            setUpdate, 
                            setFileSelected, 
                            // Pass a callback to handle success after file upload
                            () => handleSuccess()
                        ));
                    } else {
                        // For uploadDocApiCall, you might need to modify it to accept a callback
                        uploadDocApiCall(
                            logoFile, 
                            userId, 
                            editData, 
                            setLoading, 
                            setFileSelected, 
                            dispatch, 
                            // Pass callback instead of navigate
                            handleSuccess
                        )
                    }
                } else {
                    handleSuccess();
                }
            } else {
                handleSuccess();
            }
        }
        if (response.error) {
            setLoading(false)
            toast.error(`${response.error.message}`)
            dispatch(fetchUpdateUserFailure(response.error.message))
            
            // Call error callback if provided
            if (onSuccessCallback) {
                onSuccessCallback('error')
            }
        }
    }).catch((error) => {
        setLoading(false)
        toast.error(`${error.message}`)
        
        // Call error callback if provided
        if (onSuccessCallback) {
            onSuccessCallback('error')
        }
    })
}